import {onDOMReady} from './dom';

onDOMReady(() => {
    const forms = document.querySelectorAll('#frm-forgottenPasswordForm, #frm-registrationForm-registrationForm');
    forms.forEach((form) => {
        lockFormOnSubmit(form);
    });
});

const lockFormOnSubmit = (form) => {
    const hasRecaptcha = form.querySelector('.recaptcha__recaptcha');
    form.addEventListener('submit', function (e) {
        if (window.Nette && window.Nette.validateForm(form)) {
            if (!hasRecaptcha) {
                e.preventDefault();
            }

            const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');

            if (submitButton) {
                submitButton.classList.add('disabled');
                submitButton.setAttribute('disabled', 'disabled');
            }

            if (!hasRecaptcha) {
                form.submit();
            }
        }
    });
};